import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const map = {
  getDesk4meUrl(){
    return process.env.VUE_APP_URL_SERVER_BASE_DESK4ME
  },
  getClientIdDesk4me () {
    return store.getters['Client/clientIdDesk4Me']
  },
  getMap (locationId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/map`, headers)
  },
  getMapWayfinding (locationId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/wayfinding/map`, headers)
  },
  getMapWayfindingAdmin (locationId) {
    let headers = { responseType: 'arraybuffer' }
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/wayfinding/map`, headers)
  },
  getWayfindingStartPoints(locationId){
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.public}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/wayfinding/starts`)
  },
  getMapAdmin (queryParams) {
    let headers = { responseType: 'arraybuffer' }
    if(queryParams.clientId) {
      return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${queryParams.clientId}/locations/${queryParams.locationId}/map`, headers)
    }
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${queryParams}/map`, headers)
  },
  setMap (locationId, map) {
    var file = new FormData()
    file.append('mapFile', map)
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/map`, file)
  },
  setMapWayfinding (locationId, map) {
    var file = new FormData()
    file.append('mapFile', map)
    return Axios.put(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/wayfinding/map`, file)
  },
  getMapPosition (locationId) {
    return Axios.get(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${locationId}/workspaces`)
  },
  saveMapPosition(queryParams, bodyParams) {
    return Axios.post(`${this.getDesk4meUrl()}/api/${strings.apiVersion.admin}/clients/${this.getClientIdDesk4me()}/locations/${queryParams.locationId}/workspaces`, bodyParams)
  },
  getMapWithInterestZonesUrl(params) {
    let clientId = params.clientId || this.getClientIdDesk4me()
    let locationId = params.locationId

    if(!clientId || !locationId) {
      throw new Error('clientId and locationId are required')
    }

    let url = `api/v1/clients/${clientId}/locations/${locationId}/maps/interest-zones`

    if(params.space2CheckId) {
      url += `?space2CheckId=${params.space2CheckId}`
    }

    return Axios.get(url, { ignoreGlobalCatch: true })
  },
}

export default map
